import { cdnImageSrcSet, cdnImageUrl } from 'lib/cdn'
import { MEDIUM_MIN_WIDTH, ThemeName } from 'styles/theme'

export const productOpenSrcSet = (theme: ThemeName) => [
  {
    src: { 1: cdnImageUrl({ theme, imageName: 'Product-Open-xs-v2' }) },
    maxScreenWidth: 320,
  },
  {
    src: { 1: cdnImageUrl({ theme, imageName: 'Product-Open-s-v2' }) },
    maxScreenWidth: MEDIUM_MIN_WIDTH,
  },
  {
    src: { 1: cdnImageUrl({ theme, imageName: 'Product-Open-m-v2' }) },
    maxScreenWidth: 500,
  },
  {
    src: { 1: cdnImageUrl({ theme, imageName: 'Product-Open-l-v2' }) },
    maxScreenWidth: 1440,
  },
  {
    src: { 1: cdnImageUrl({ theme, imageName: 'Product-Open-xl-v2' }) },
    maxScreenWidth: 1919,
  },
]

export const productPourSrcSet = (theme: ThemeName) => [
  {
    src: {
      1: cdnImageUrl({ theme, imageName: 'Product-Pour-v4', width: 250 }),
    },
    maxScreenWidth: 320,
  },
  {
    src: {
      1: cdnImageUrl({ theme, imageName: 'Product-Pour-v4', width: 300 }),
    },
    maxScreenWidth: MEDIUM_MIN_WIDTH,
  },
  {
    src: {
      1: cdnImageUrl({ theme, imageName: 'Product-Pour-v4', width: 325 }),
    },
    maxScreenWidth: 930,
  },
  {
    src: {
      1: cdnImageUrl({ theme, imageName: 'Product-Pour-v4', width: 400 }),
    },
    maxScreenWidth: 1690,
  },
]

export type WaterSize = 'xs' | 's' | 'm' | 'l' | 'xl'

export const waterSpriteUrl = (size: WaterSize, theme: ThemeName) =>
  cdnImageUrl({
    theme,
    imageName: `Pour-Loop_${size}-v2`,
  })

export const waterSrcSet = (theme: ThemeName) => [
  {
    src: {
      1: waterSpriteUrl('xs', theme),
    },
    maxScreenWidth: 320,
  },
  {
    src: {
      1: waterSpriteUrl('s', theme),
    },
    maxScreenWidth: MEDIUM_MIN_WIDTH,
  },
  {
    src: {
      1: waterSpriteUrl('m', theme),
    },
    maxScreenWidth: 930,
  },
  {
    src: {
      1: waterSpriteUrl('l', theme),
    },
    maxScreenWidth: 1690,
  },
]

export const productClosedSrcSet = (theme: ThemeName) => [
  {
    src: cdnImageSrcSet({
      theme,
      imageName: 'Product-Closed-v7',
      width: 140,
    }),
    maxScreenWidth: 376,
  },
  {
    src: cdnImageSrcSet({
      theme,
      imageName: 'Product-Closed-v7',
      width: 210,
    }),
    maxScreenWidth: 768,
  },
]
